import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgRefresh = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M8.333 9.167H5.917v-.008a4.13 4.13 0 0 1 .627-1.489 4.212 4.212 0 0 1 1.834-1.51c.251-.106.514-.187.781-.242a4.232 4.232 0 0 1 1.682 0c.798.164 1.53.558 2.104 1.135l1.18-1.177a5.863 5.863 0 0 0-1.853-1.25 5.765 5.765 0 0 0-1.096-.34 5.9 5.9 0 0 0-2.35 0 5.867 5.867 0 0 0-3.663 2.452 5.815 5.815 0 0 0-.878 2.087c-.023.113-.036.228-.052.342H1.666L4.999 12.5l3.334-3.333Zm3.333 1.666h2.416l-.001.007a4.146 4.146 0 0 1-1.752 2.615c-.45.305-.957.518-1.49.627a4.227 4.227 0 0 1-1.68 0 4.13 4.13 0 0 1-2.106-1.135l-1.179 1.178a5.86 5.86 0 0 0 1.855 1.25c.353.15.722.264 1.095.34a5.891 5.891 0 0 0 2.349 0 5.86 5.86 0 0 0 3.662-2.454c.426-.631.725-1.34.878-2.086.022-.112.036-.227.052-.342h2.568L14.999 7.5l-3.333 3.333Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgRefresh);
export default ForwardRef;
